import { render, staticRenderFns } from "./AppBtnGroup.vue?vue&type=template&id=41c9d168&"
var script = {}
import style0 from "./AppBtnGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VItemGroup})
